// extracted by mini-css-extract-plugin
export default {"divider":"TableFiltersSection_divider__j7XDT","host":"TableFiltersSection_host__zafjF"};